import { useCallback, useEffect, useState } from 'react';

import { useAuth0 } from '@auth0/auth0-react';

import useGlobalStore from 'hooks/useGlobalStore';

const useLogout = () => {
    const [logMeOut, setLogMeout] = useState(false);

    const { logout: logoutAuth0 } = useAuth0();

    const { clear, getValue, setValue } = useGlobalStore({ namespace: 'useLogout' });

    const logout = useCallback(() => {
        setValue({ isLoggingOut: false });
        clear();
        setLogMeout(true);
    }, [clear, setValue]);

    useEffect(() => {
        (async () => {
            if (logMeOut) {
                await logoutAuth0();

                setLogMeout(false);
            }
        })();
    }, [logoutAuth0, logMeOut]);

    return {
        isLoggingOut: getValue('isLoggingOut'),
        logout
    };
};

export default useLogout;
